import { useEffect, useState } from "react";

// gallery.php used the W3Schools filterSelection() snippet, toggling a "show"
// class on .column elements. The category class names are leftovers from that
// template — "nature"/"cars"/"people" are what the markup actually carries, so
// they are kept as the filter keys and only the button labels are meaningful.

const FILTERS = [
  { key: "all", label: " Show all" },
  { key: "nature", label: " Meetings" },
  { key: "cars", label: " Events" },
  { key: "people", label: " Seminar" },
];

export default function GalleryFilter() {
  const [active, setActive] = useState("all");

  // The .column elements are plain markup carried over from the PHP page, so
  // the "show" class is applied to them directly rather than through props.
  useEffect(() => {
    const columns = Array.from(document.querySelectorAll<HTMLElement>(".column"));
    for (const col of columns) {
      col.classList.toggle("show", active === "all" || col.classList.contains(active));
    }
  }, [active]);

  return (
    <div id="myBtnContainer" style={{ marginBottom: "20px" }}>
      {FILTERS.map((f) => (
        <button
          key={f.key}
          type="button"
          className={`btn${active === f.key ? " active" : ""}`}
          onClick={() => setActive(f.key)}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
